import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { useHistory } from "react-router-dom";
import { auth, firestore } from "../../firebase";
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { Box } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import { Alert } from "mdi-material-ui";
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 320,
    margin: 15,
    marginBottom: 20,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 0,
    marginTop: 0,
  },
  root1: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.primary,
  },
}));
function EmptyState(props) {
  let imageWidth;
  let imageHeight;
  let variant;

  const [mobileNumber, setMobileNumber] = useState('');
  const [rewards, setRewards] = useState('');
  const classes = useStyles();

  const onCheckRewards = () => {
    firestore.collection('Employees').where('mobileNumber', '==', mobileNumber).get().then(querySnapshot => {
      const listItems = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
      if(listItems.length>0) {
        setRewards(listItems[0].rewards + " ");
      } else {
        setRewards("Mobile Number does not exists.");
      }
      //alert("Success");
     // props.openSnackbar("Success!");
    });
  }

  switch (props.size) {
    case "small":
      imageWidth = 40;
      imageHeight = 40;
      variant = "h6";
      break;

    case "medium":
      imageWidth = 60;
      imageHeight = 60;
      variant = "h6";
      break;

    case "large":
      imageWidth = 100;
      imageHeight = 100;
      variant = "h4";
      break;

    default:
      imageWidth = 60;
      imageHeight = 60;
      variant = "h5";
      break;
  }

  if (props.type === "page") {
    return (
      <Box
        style={{ transform: "translate(-50%, -50%)" }}
        position="absolute"
        top="50%"
        left="50%"
        textAlign="center"
      >
        
        <Card className={classes.root}>
          <CardContent>
          <img alt="" src="logo192.png"></img>
            <Typography variant="h6" className={classes.pos}>
              Check Your Reward Points!
            </Typography>
           { rewards &&  <Typography variant="h6" className={classes.pos}>
              <MonetizationOnIcon/> 
              <Typography variant="h4" className={classes.pos}>
              {rewards}
            </Typography>
            </Typography>
        }
          </CardContent>
          <CardActions>
            <Grid item xs={12}>
              <TextField
                id="filled-number"
                label="Mobile Number"
                type="number"
                onInput={(e) => {
                  e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 10);
                  setMobileNumber(e.target.value);
                }}
                placeholder="9723622285"
                variant="filled"
                fullWidth
                margin="normal"
                value={mobileNumber}
              />
              <Button fullWidth variant="contained" color="primary" onClick={() => onCheckRewards()} size="medium">Get Reward Points</Button>
            </Grid>
          </CardActions>
        </Card>
        <Divider />

        {/* {props.image && (
          <Box
            className={classes.root}
            clone
            mb={props.title || props.description ? 2 : 0}
            width={`${imageWidth}%`}
            height={`${imageHeight}%`}
          >
            {props.image}
          </Box>
        )} */}

        {props.title && (
          <Box mb={!props.description && props.button ? 2 : 0.5}>
            <Typography variant={variant}>{props.title}</Typography>
          </Box>
        )}

        {/* {props.description && (
          <Box mb={props.button && 3}>
            <Typography variant="body1">{props.description}</Typography>
          </Box>
        )} */}

        {props.button && props.button}
      </Box>
    );
  }

  if (props.type === "card") {
    return (
      <>

        <Box padding={props.padding} textAlign="center">
          {props.image && (
            <Box
              clone
              mb={props.title || props.description ? 2 : 0}
              width={`${imageWidth}%`}
              height={`${imageHeight}%`}
            >
              {props.image}
            </Box>
          )}

          {props.title && (
            <Box mb={!props.description && props.button ? 2 : 0}>
              <Typography variant={variant}>{props.title}</Typography>
            </Box>
          )}

          {props.description && (
            <Box mb={props.button && 2}>
              <Typography variant="body1">{props.description}</Typography>
            </Box>
          )}

          {props.button && props.button}
        </Box>
      </>
    );
  }

  return null;
}

EmptyState.defaultProps = {
  type: "page",
  size: "medium",
  padding: 2,
};

EmptyState.propTypes = {
  type: PropTypes.string,
  size: PropTypes.string,
  padding: PropTypes.number,

  image: PropTypes.element,
  title: PropTypes.string,
  description: PropTypes.string,
  button: PropTypes.element,
};

export default EmptyState;
